import React from 'react'
import styles from './FileAttachment.module.css'

const FileAttachment = (props) => {
    const { fileName, fileType,onRemoveFileFromAttachmentsClicked,id } = props

    let iconString
    switch (fileType) {
        case 'gif':
        case 'jpg':
        case 'jpeg':
        case 'png':
            iconString = `${styles['file-icon']} fa-regular fa-file-image ${styles['file-image']}`
            break;
        case 'doc':
        case 'docx':
            iconString = `${styles['file-icon']} fa-regular fa-file-word ${styles['file-word']}`
            break;
        case 'pdf':
            iconString = `${styles['file-icon']} fa-regular fa-file-pdf ${styles['file-pdf']}`
            break;
        case 'mp3':
        case 'wav':
        case 'ogg':
        case 'webm':
        case 'aac':
        case 'm4a':
            iconString = `${styles['file-icon']} fa-regular fa-file-audio ${styles['file-audio']}`
            break;
        case 'csv':
        case 'xls':
        case 'xlsx':
            iconString = `${styles['file-icon']} fa-regular fa-file-excel ${styles['file-excel']}`
            break;
        case 'pptx':
        case 'ppt':
            iconString = `${styles['file-icon']} fa-regular fa-file-powerpoint ${styles['file-ppt']}`
            break
        case 'txt':
            iconString = `${styles['file-icon']} fa-regular fa-file-lines ${styles['file-text']}`
            break
        case 'mp4':
            iconString = `${styles['file-icon']} fa-regular fa-file-video ${styles['file-video']}`
            break
        default:
            iconString = `${styles['file-icon']} fa-regular fa-circle-question ${styles['file-question']}`
    }

    return (
        <div className={styles['single-file-attachment']}>
            <i className={iconString} />
            <h3 className={`${styles['file-name']}`}>{fileName}</h3>
            <i class={`${styles['remove-file-icon']} fa-regular fa-circle-xmark`} onClick={()=>onRemoveFileFromAttachmentsClicked(id)}/>
        </div>
    )
}

export default FileAttachment